import { type QueryClient } from '@tanstack/react-query';

import { BX_HYBRID_SEARCH_EXPERIMENT } from '@/app/node/constants/experiments';
import { type TExperiments } from '@/app/shared/types/experiments';

import { FetchGetUserLoadService } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/load';

import { type IFastFiltersUserSchema } from '@/repositories/generated/shared/monolith-python/entities/schemas/FastFiltersUserSchema';

interface IGetAnalyticsUserParams {
  queryClient: QueryClient;
  experiments: TExperiments;
}

export type AnalyticsUser = { userId: number } | {};

export function getAnalyticsUser(params: IGetAnalyticsUserParams): AnalyticsUser {
  const user = getUser(params);

  const extra = getUserExtra(params);

  return user?.isAuthenticated ? { userId: user.userId as number, extra } : { extra };
}

function getUser({ queryClient }: IGetAnalyticsUserParams): IFastFiltersUserSchema | undefined {
  const userData = new FetchGetUserLoadService(queryClient).getQueryData();

  return userData?.data.user;
}

function getUserExtra({ experiments }: IGetAnalyticsUserParams): Record<string, unknown> | undefined {
  const hybridSearchExperimentGroup = (experiments[BX_HYBRID_SEARCH_EXPERIMENT] || 'A').toLocaleLowerCase();

  return {
    [BX_HYBRID_SEARCH_EXPERIMENT]: hybridSearchExperimentGroup,
  };
}
